import { render, staticRenderFns } from "./Disease.vue?vue&type=template&id=738e2712&"
import script from "./Disease.vue?vue&type=script&lang=js&"
export * from "./Disease.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports